import React, { useContext, useEffect, useState } from "react";
import Container from "../components/Container";
import arrow from "../assets/vector.png";
import { AuthContext } from "../AuthContext";
import { httpRequest } from "../services/http";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";

const ApplicationsPage = () => {
  // const titles = ["Comptabilité & Finance", "Ressources Humaines", "Vente & Commerce", "Productivité"]
  const { token, isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let active = true;
    const fetchApps = async () => {
      try {
        setLoading(true);
        const data = await httpRequest("/applications", {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        if (!active) return;
        const list = Array.isArray(data?.applications) ? data.applications : [];
        setApps(list);
      } catch (e) {
        console.error("Erreur de chargement des apps", e);
      } finally {
        if (active) setLoading(false);
      }
    };
    fetchApps();
    return () => {
      active = false;
    };
  }, [token]);

  const handleAppClick = (app) => {
    try {
      // Vérifier si l'utilisateur est connecté
      if (!isAuthenticated || !token) {
        // Stocker l'application cliquée pour l'exécuter après connexion
        sessionStorage.setItem("pendingAppClick", JSON.stringify(app));
        toast.error("Veuillez vous connecter pour accéder à cette application");
        navigate("/login");
        return;
      }

      // ✅ Rediriger DIRECTEMENT avec le token Easy Suite
      const redirectPath = app.redirect_path || "/dashboard";
      const redirectUrl = `${app.frontend_url}${redirectPath}?token=${token}`;

      console.log("🚀 Redirection vers:", redirectUrl);

      // Rediriger l'utilisateur
      window.location.href = redirectUrl;
    } catch (e) {
      console.error("Erreur lors de la redirection", e);
      alert("Erreur de connexion à l'application");
    }
  };
  return (
    <section id="applications" className="py-6 md:py-16">
      <div className="flex flex-col items-center justify-center px-4">
        <h1 className="text-xl md:text-2xl lg:text-5xl text-[#0A0A0A] text-center font-extrabold font-montserrat tracking- mb-2 leading-[-1%]">
          Tous les outils dont vous avez besoin
        </h1>
        <div className="flex justify-center items-center py-2">
          <div className="w-[300px]">
            <img src={arrow} alt="arrow" className="object-cover" />
          </div>
        </div>
        <p className="text-center text-[#000000] mt-1 mb-8 md:mb-12 font-semibold font-segoe text-base md:text-[26px]">
          Des outils modernes, intégrés et conçus pour simplifier votre
          quotidien.
        </p>
      </div>
      <div className="bg-[#F5F8FF] py-[40px]">
        <Container className="relative z-10">
          {/* {titles.map((title, idx) => ( */}
          <div className="mb-10">
            {/* <h2 className='text-xl text-[#0A0A0A] font-bold font-segoe tracking-[0%] mb-2 leading-[36px]'>{title}</h2> */}
            {loading ? (
              <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
                {/* Skeleton loaders - 8 cards */}
                {[...Array(8)].map((_, index) => (
                  <div
                    key={index}
                    className="md:h-64 rounded-xl bg-white p-6 animate-pulse"
                  >
                    <div className="w-[80%] h-full">
                      {/* Logo skeleton */}
                      <div className="w-14 h-14 bg-gray-200 rounded-lg mb-6"></div>
                      {/* Titre skeleton */}
                      <div className="h-7 bg-gray-200 rounded mb-6 w-3/4"></div>
                      {/* Description skeleton */}
                      <div className="space-y-2">
                        <div className="h-4 bg-gray-200 rounded w-full"></div>
                        <div className="h-4 bg-gray-200 rounded w-5/6"></div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
                {apps.map((app, id) => (
                  <button
                    type="button"
                    onClick={() => handleAppClick(app)}
                    className="card-link hover:shadow-md transition-shadow hover:scale-105 md:h-64 rounded-xl bg-white p-6 transition-all duration-300"
                  >
                    <div className="w-[80%] h-full">
                      <div
                        className={`w-14 h-14 bg-[#ECECF0] rounded-lg flex items-center mb-6 justify-center`}
                      >
                        {app.logo_url && (
                          <img
                            src={app.logo_url}
                            alt={app.name}
                            className="h-12 w-12 object-contain mb-3"
                          />
                        )}
                      </div>
                      <h3 className="text-2xl text-start font-extrabold mb-6 tracking-[0.31px]  text-[#034D82] ">
                        {app.name}
                      </h3>
                      <p className="text-base text-start text-[#717182] font-medium font-segoe tracking-[0%] line-clamp-2 overflow-hidden">
                        {app.description}
                      </p>
                    </div>
                  </button>
                ))}
              </div>
            )}
          </div>
          {/* ))} */}
        </Container>
      </div>
    </section>
  );
};

export default ApplicationsPage;
